<app-table-form-container
	[loading]="loading()"
	modelName="Activity"
	[showForm]="isFormShowing()"
	(onShowForm)="onShowForm()"
	(onHideForm)="onHideForm()"
>
	<ng-template #tableTemplate>
		<app-cms-table
			[tableKey]="'activity-list'"
			[loading]="loading()"
			[rows]="activities()"
			[columns]="columns()"
			[selectedUuid]="editActivity()?.uuid"
			[previewingUuid]="previewActivity()?.uuid"
			[uuidsInProgress]="uuidsInProgress()"
			(onSelect)="select($event)"
			(onCopy)="copy($event)"
			(onCopyBulk)="copyBulk($event)"
			(onEdit)="edit($event)"
			(onDelete)="delete$($event)"
			(onMoveUp)="moveUp$($event)"
			(onMoveDown)="moveDown$($event)"
			(onPreview)="preview($event)"
		>
			<!-- Header templates (defines order/keys) -->
			<ng-template appHeaderColumn="activityName">Activity</ng-template>
			<ng-template appHeaderColumn="skillSummaries">Skill</ng-template>
			<ng-template appHeaderColumn="rubricLevelSummaries">Level</ng-template>
			<ng-template appHeaderColumn="status">Status</ng-template>

			<!-- Cell templates (matched by key; use {{ row.name }} etc.) -->
			<ng-template appRowColumn="activityName" let-row>
				<div class="name-column clickable">
					{{ row.active_text.name }}
				</div>
			</ng-template>
			<ng-template appRowColumn="skillSummaries" let-row>
				<div>
					<app-skill-summary [activity]="row"></app-skill-summary>
				</div>
			</ng-template>
			<ng-template appRowColumn="rubricLevelSummaries" let-row>
				<div>
					<app-rubric-level-summary [activity]="row"></app-rubric-level-summary>
				</div>
			</ng-template>
			<ng-template appRowColumn="status" let-row>
				<div (click)="$event.stopPropagation()">
					@if (isAdmin()) {
						<app-product-status-select
							[uuid]="row.status_uuid"
							[productName]="adminService.selectedCourse$.value?.product_name"
							(onChange)="onProductStatusChange(row, $event)"
						></app-product-status-select>
					} @else {
						{{ row.status_uuid }}
					}
				</div>
			</ng-template>
		</app-cms-table>

		@if (previewActivity()) {
			<app-preview-activity
				[activity]="previewActivity()"
				(onClear)="preview(undefined)"
				(onPreview)="preview($event)"
			></app-preview-activity>
		}
	</ng-template>

	<ng-template #formTemplate>
		<nz-card>
			<app-language-selector (onChange)="onEditLanguageChange($event)"></app-language-selector>
			<app-activity-form
				[activity]="editActivity()"
				[editLanguage]="editLanguage()"
				(onSubmit)="onActivityFormSubmit$($event)"
			></app-activity-form>
		</nz-card>
	</ng-template>
</app-table-form-container>
